import React from 'react';
import URL from '@/finsight/Router/urlConstants';
import IconBondManager from '@dealroadshow/uikit/core/components/Icon/IconBondManager';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import ExportToExcelButton from './ExportToExcelButton';

import styles from './bondsTileTools.scss';

interface IProps {
  isVisible: boolean,
}

const BondsTileTools = ({ isVisible }: IProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={ styles.bondTileTools }>
      <div className={ styles.excelWrapper }>
        <ExportToExcelButton className={ styles.excelButton } />
      </div>
      <Tooltip content="Go to US ABS BWICS & Inventory">
        <a
          href={ `${ URL.BONDS_INVENTORIES_ABS }` }
          target="_blank"
          data-test="goToBondsLink"
        >
          <IconBondManager
            className={ styles.bondsIcon }
          />
        </a>
      </Tooltip>
    </div>
  );
};

export default BondsTileTools;
